export const BASE_JWT_URL = process.env.REACT_APP_JWT_BASE_URL;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;

// Mapbox
export const MAPBOX_KEY = process.env.REACT_APP_MAPBOX_KEY;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

// Google Tag
export const GOOGLE_TAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID;

// AWS Cognito
export const COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI;

//Material UI
export const MUI_KEY = process.env.REACT_APP_MUI_KEY;

/** Set in .env.local to override locale locally (e.g. REACT_APP_LOCALE_OVERRIDE=es) */
export const REACT_APP_LOCALE_OVERRIDE = process.env.REACT_APP_LOCALE_OVERRIDE;

//Intercom
export const INTERCOM_ID = process.env.REACT_APP_INTERCOM_ID;

//Pusher
export const AIRMESH_LIVE_TELEMETRY_PUSHER_APP_KEY =
	process.env.REACT_APP_AIRMESH_LIVE_TELEMETRY_PUSHER_APP_KEY;
export const AIRMESH_LIVE_TELEMETRY_PUSHER_APP_CLUSTER =
	process.env.REACT_APP_AIRMESH_LIVE_TELEMETRY_PUSHER_APP_CLUSTER;

// App Title
export const APP_TITLE = process.env.REACT_APP_TITLE || 'Air Control';
